<script>
import {
  CdrText,
  CdrLink,
} from '@rei/cedar';
import formatContentAuthor from '../../../utils/formatContentAuthor';

export default {
  name: 'BylineAndPublishDate',
  components: {
    CdrText,
    CdrLink,
  },
  props: {
    datePublished: {
      type: String,
      required: false,
      default: null,
    },
    dateUpdated: {
      type: String,
      required: false,
      default: null,
    },
    authors: {
      type: Array,
      required: false,
      default: null,
    },
  },
  data: () => ({
    baseClassName: 'articleByline',
  }),
  computed: {
    formattedAuthors() {
      const [firstAuthor, secondAuthor] = this.authors;

      return {
        first: formatContentAuthor(firstAuthor),
        second: formatContentAuthor(secondAuthor),
      };
    },
    authorLinks() {
      const [firstAuthor, secondAuthor] = this.authors;

      return {
        first: firstAuthor?.slug || false,
        second: secondAuthor?.slug || false,
      };
    },
    hasAuthors() {
      return this.authors?.length > 0;
    },
    isUpdated() {
      return this.dateUpdated;
    },
    contentDate() {
      const dateFormat = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      };
      const date = this.dateUpdated || this.datePublished;
      let formattedDate;
      if (date) {
        try {
          const parsedDate = new Date(date);

          if (Number.isNaN(parsedDate.getDate())) {
            return false;
          }

          formattedDate = parsedDate.toLocaleDateString(undefined, dateFormat);
        } catch (e) {
          // Log somewhere?
        }
      }
      return formattedDate;
    },
  },
};

</script>
<template>
  <cdr-text
    v-if="hasAuthors"
    :class="`${baseClassName}`"
  >
    <span
      v-if="formattedAuthors.first"
      data-test="first-author"
    >
      <cdr-link
        v-if="authorLinks.first"
        :href="`${authorLinks.first}`"
      >
        {{ formattedAuthors.first }}
      </cdr-link>
      <span
        v-else
      >
        {{ formattedAuthors.first }}
      </span>
    </span>

    <span
      v-if="formattedAuthors.second"
      data-test="second-author"
    >
      <span :class="`${baseClassName}__spacer`">|</span>
      <cdr-link
        v-if="authorLinks.second"
        :href="`${authorLinks.second}`"
      >
        {{ formattedAuthors.second }}
      </cdr-link>
      <span
        v-else
      >
        {{ formattedAuthors.second }}
      </span>
    </span>

    <span
      v-if="contentDate"
      data-test="content-date"
    >
      <span :class="`${baseClassName}__spacer`">|</span>
      {{ (isUpdated ? 'Updated ' : 'Published ') + contentDate }}
    </span>
  </cdr-text>
</template>

<style lang="scss">
@import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss';

$baseClassName: 'articleByline';

.#{$baseClassName} {
    @include cdr-text-utility-sans-300;

    .#{$baseClassName}__spacer {
      line-height: 100%;
      overflow: hidden;
      margin: 0 $cdr-space-half-x;

        @include cdr-sm-mq-down {
          display: block;
          height: 0;
        }
    }
  }
</style>
